/**
 * Maintenance-mode gating.
 *
 *   MAINTENANCE_MODE  → REACT_APP_MAINTENANCE_MODE=true (in frontend/.env)
 *   PREVIEW BYPASS    → append ?preview=<token> to any URL once, and the flag
 *                       is persisted in localStorage under 'cides_preview'.
 *                       Remove it by appending ?preview=off.
 *
 * The preview token is intentionally NOT a security boundary — it just hides
 * the pre-launch site from casual visitors. Change PREVIEW_TOKEN below to
 * rotate access.
 */
export const PREVIEW_TOKEN = "cides-preview-2026";
const STORAGE_KEY = "cides_preview";

export const isMaintenanceEnabled = () =>
  String(process.env.REACT_APP_MAINTENANCE_MODE || "").toLowerCase() === "true";

export const hasPreviewAccess = () => {
  try {
    if (typeof window === "undefined") return false;

    const params = new URLSearchParams(window.location.search);
    const q = params.get("preview");

    if (q === "off") {
      window.localStorage.removeItem(STORAGE_KEY);
      return false;
    }

    if (q && q === PREVIEW_TOKEN) {
      window.localStorage.setItem(STORAGE_KEY, "1");
      return true;
    }

    return window.localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
};

/**
 * Should the site render its normal pages?
 * true → maintenance is OFF, or user has preview access.
 */
export const shouldShowFullSite = () =>
  !isMaintenanceEnabled() || hasPreviewAccess();
